import React from 'react';
import { Users } from 'lucide-react';
import { relativeTime } from '../../lib/recents';

/**
 * "Shared by Olly" — shown on a publication that arrived through a share link (its `shared_from` / `sharedFrom` note),
 * so people remember where a copy came from. Renders nothing for the owner's own publications.
 */
export const SharedBadge = ({ sharedFrom, size = 'sm', className = '', testId }) => {
  if (!sharedFrom?.name) return null;
  const when = sharedFrom.at ? relativeTime(sharedFrom.at) : '';
  const compact = size === 'xs';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-primary/25 bg-primary/10 text-primary font-medium whitespace-nowrap max-w-full min-w-0 ${compact ? 'px-1.5 py-px text-[10px]' : 'px-2 py-0.5 text-[11px]'} ${className}`}
      title={`Copied from a publication shared by ${sharedFrom.name}${when ? ` · ${when}` : ''}`}
      data-testid={testId || 'shared-badge'}
    >
      <Users className={`shrink-0 ${compact ? 'h-2.5 w-2.5' : 'h-3 w-3'}`} aria-hidden="true" />
      <span className="truncate">Shared by {sharedFrom.name}</span>
    </span>
  );
};
